import IntlMessages from "util/IntlMessages";
import {Menu} from "antd";
import {Link} from "react-router-dom";
import React from "react";
import {useDispatch} from "react-redux";

import {THEME_TYPE_LITE} from "../../constants/ThemeSetting";
import { DeleteKeysFromSession } from "../../routes/recruitment/screening/utils";
import { fetchEmployeePerformenceAssessment, fetchEmployees } from "../../appRedux/actions";
import dayjs from "dayjs";

const HumanResourceSideBar = ({navStyleClass, defaultOpenKeys, selectedKeys, themeType, user}) => {
  const dispatch = useDispatch();

  const keysToDeleteFromSession = ['pageSize','employeePageNo','profilePageNo','submissionPageNo',
    'assessmentPageNo','clientPagination','pocPageNo','ipPageNo','transferRequestPageNo','offersPageNo',
    'supportPersonsoffersPageNo','supportInvoicePageNo']
    
  const fetchProjectCoordinators = () => {
    dispatch(fetchEmployees(1 ,null ,'project_coordination', 'user'))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }

  const fetchRecruiterList = () => {
    DeleteKeysFromSession(keysToDeleteFromSession)
    dispatch(fetchEmployees(1, null, 'recruitment', 'user'));
  };

  const fetchMarketerList = () => {
    DeleteKeysFromSession(keysToDeleteFromSession)
    dispatch(fetchEmployees(1, null, 'marketing', 'user'));
  };

  const fetchEngineersList = () => {
    dispatch(fetchEmployees(1 ,null ,'engineering'))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }

  const fetchContractPersonsList = () => {
    dispatch(fetchEmployees(1 ,null ,'contract'))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }
  const fetchEmployeeList = () => {
    DeleteKeysFromSession(keysToDeleteFromSession)
    dispatch(fetchEmployees());
  };

  const fetchEmployeePerformenceData = () => {
    const from_date = dayjs().startOf('month').format('YYYY-MM-DD');
    const to_date = dayjs().format('YYYY-MM-DD');
    dispatch(fetchEmployeePerformenceAssessment({from_date: from_date, to_date:to_date}))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }

  return (
        <Menu defaultOpenKeys={[defaultOpenKeys]} selectedKeys={[selectedKeys]} theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'} mode="inline">

          <Menu.Item style={{color:"white"}}>Employee</Menu.Item>
          <Menu.Item key="employee.recruiters">
            <Link to={"/".concat(user.username.concat("/human_resource/recruiter/list"))}
                  onClick={() => fetchRecruiterList()}
                  >
                <i className="icon icon-profile"/><IntlMessages id="sidebar.recruiters"/></Link>
          </Menu.Item>
          <Menu.Item key="employee.marketers">
            <Link to={"/".concat(user.username.concat("/human_resource/marketer/list"))}
                  onClick={() => fetchMarketerList()}
                  >
              <i className="icon icon-profile"/>
                <IntlMessages id="sidebar.marketers"/></Link>
          </Menu.Item>
          <Menu.Item key="project_coordination.projectcoordinators">
            <Link to={"/".concat(user.username.concat("/human_resource/project_coordinators"))} 
              onClick={()=>fetchProjectCoordinators()}
              > <i className="icon icon-card"/>
              <span style={{ display: 'inline-block', lineHeight: 1, marginBottom: '0px', transform: 'translate(0px, 8px)', top: '10px'}} >
                Project <br></br> Coordinator
              </span>
            </Link>
          </Menu.Item>
          <Menu.Item key="employee.projectcoordinators">
            <Link to={"/".concat(user.username.concat("/human_resource/engineers/list"))} 
              onClick={()=>fetchEngineersList()}
              > <i className="icon icon-card"/>
              <IntlMessages id='sidebar.listType.engineers' />
            </Link>
          </Menu.Item>
          <Menu.Item key="contract.contrats">
              <Link to={"/".concat(user.username.concat("/human_resource/contract-person/list"))} 
              onClick={()=>fetchContractPersonsList()} > <i className="icon icon-card"/>
              Contract
              </Link>
          </Menu.Item>
          <Menu.Item key="employee.all">
            <Link to={"/".concat(user.username.concat("/human_resource/employee/list"))}
              onClick={() =>fetchEmployeeList()}
            >
              <span>
                  <i className="icon icon-map-street-view"/>
                <IntlMessages id="sidebar.employees"/></span></Link>
          </Menu.Item>
          <Menu.Item style={{color:"white"}}>Marketeing</Menu.Item>
          <Menu.Item key="contract.contrats">
              <Link to={"/".concat(user.username.concat("/assessment-data"))} 
              onClick={()=>fetchContractPersonsList()} > <i className="icon icon-card"/>
              Assessment Data
              </Link>
          </Menu.Item>
        </Menu>
);
};
export default HumanResourceSideBar;
